"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const fa_1 = require("react-icons/fa");
const md_1 = require("react-icons/md");
const categorie_api_1 = require("../../../../utils/api/categorie/categorie.api");
const AddOrUpdateCategoryModal_1 = __importDefault(require("../modals/AddOrUpdateCategoryModal"));
const UseCrudCategorie_1 = require("../requestForm/UseCrudCategorie");
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const UpdateTariffButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-edit", "data-tooltip-content": "Modifier", onClick: handleShow },
            react_1.default.createElement(md_1.MdEdit, { className: "edit-action-icon" })),
        react_1.default.createElement(AddOrUpdateCategoryModal_1.default, { show: show, handleClose: handleClose, item: item })));
};
const DeleteCategoryButton = ({ id }) => {
    const onDelete = (0, UseCrudCategorie_1.UseDeleteCategorie)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" }, onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const CategorieAdminTable = () => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const [query, setQuery] = (0, react_1.useState)("");
    const { data = { data: [], count: 0 }, isLoading } = (0, categorie_api_1.useGetCategoriesQuery)({});
    const paginatedData = data.data.slice((page - 1) * perPage, page * perPage);
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement(UpdateTariffButton, { item: row }),
            react_1.default.createElement(DeleteCategoryButton, { id: row.id })));
    };
    const columns = [
        {
            dataField: "name",
            text: "Nom",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "type",
            text: "Type",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: data === null || data === void 0 ? void 0 : data.count, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))))));
};
const datas = [
    {
        id: 1,
        poste: "Pikine Nord  & Sud",
        moto: "300",
        voiture_leger: "300",
        mini_bus: 300,
        poids_lourd: "300",
    },
    {
        id: 2,
        poste: "Thiaroye Nord et Sud",
        moto: "300",
        voiture_leger: "300",
        mini_bus: "300",
        poids_lourd: "300",
    },
    {
        id: 3,
        poste: "Thiaroye BPV",
        moto: "300",
        voiture_leger: "300",
        mini_bus: 300,
        poids_lourd: "300",
    },
    {
        id: 4,
        poste: "Keur Massar Nord & Sud",
        moto: "300",
        voiture_leger: "300",
        mini_bus: 300,
        poids_lourd: "300",
    },
    {
        id: 5,
        poste: "Rufisque BPV",
        moto: "300",
        voiture_leger: "300",
        mini_bus: 300,
        poids_lourd: "300",
    },
    {
        id: 6,
        poste: "Rufisque BPV",
        moto: "300",
        voiture_leger: "300",
        mini_bus: 300,
        poids_lourd: "300",
    },
    {
        id: 7,
        poste: "Sébikotane Nord & Sud",
        moto: "300",
        voiture_leger: "300",
        mini_bus: 300,
        poids_lourd: "300",
    },
];
exports.default = CategorieAdminTable;
